module.exports = __webpack_public_path__ + "img/step3.e0f3dd13.svg";